import React from 'react'
import './style.scss'

export default function Checkbox({ id, onChange }) { 

    const handleChange = (e) => {
        onChange()
    }

    return (
        <>
            <label className="container calibri">
                <input onChange={handleChange} id={id} type="checkbox" />
                <span className="checkmark"></span>
            </label>
        </>
    )
}